module.exports = __webpack_public_path__ + "img/WindfishPoster.85e585d1.jpg";